import { clientApi } from '../../configuration';
import { getPermissionsHook } from '../../utils';

type PermissionCodes =
  | 'DISPLAY_ENROLLMENT_DASHBOARD'
  | 'DISPLAY_PROFILE_STEP'
  | 'DISPLAY_ORIENTATION_STEP'
  | 'DISPLAY_FINALISATION_STEP'
  | 'HAVE_RECRUITEMENT_STEP'
  | 'DISPLAY_RECRUITMENT_STEP'
  | 'DISPLAY_DISQUALIFICATION_STEP'
  | 'DISPLAY_ENROLLMENT_COMPLETE';

const useEnrollmentPermissions = getPermissionsHook<PermissionCodes, 'userEnrollmentPermissions'>({
  entityName: 'userEnrollmentPermissions',
  apiResponseRootKey: 'userEnrollmentPermissions',
  fetch: ({ userId }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).enrollmentPermissions.get(),
});

export default useEnrollmentPermissions;
